module.exports = __webpack_public_path__ + "img/012.4cf3d004.jpg";